import { CoursesIcon, Table } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { useTranslation } from 'react-i18next';
import { UseCoursesTableFragment, useCoursesTable } from '../hooks/useCoursesTable';
import { CourseTableType } from '../types/types';

type CoursesPreviewTableProps = {
  query: FragmentType<typeof UseCoursesTableFragment> | undefined;
  onNavigate: (uuid: string) => void;
};

export const CoursesPreviewTable = ({ query, onNavigate }: CoursesPreviewTableProps) => {
  const { t } = useTranslation();

  const { data, columns } = useCoursesTable({ query, showCourseInfo: true, columns: ['name'], onNavigate });

  return (
    <Table<CourseTableType>
      hideHeader
      customPadding='var(--spacing-6)'
      customRowHeight='var(--list-row-height)'
      customLastColSpacing='0'
      isDesktop={true}
      data={data}
      columns={columns}
      emptyStateSettings={{
        icon: <CoursesIcon className='svg-icon primary-light' />,
        size: 'small',
        title: '',
        subtitle: t('courses.noCourses'),
        padding: 'xl',
      }}
    />
  );
};
